import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { computeQuote } from "./quote.server";
import type { QuoteResult } from "./pricing";

export const getQuote = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) =>
    z
      .object({
        origen: z.string().trim().min(3).max(200),
        destino: z.string().trim().min(3).max(200),
        idaYVuelta: z.boolean(),
      })
      .parse(data),
  )
  .handler(async ({ data }): Promise<QuoteResult> => computeQuote(data));
